import { Node, Transforms } from 'slate'
import { ReactEditor } from 'slate-react'
import { EditorService, IDashboardElement, IDashboardWidgetElement } from '../EditorService'
import { ContentCommands } from '../commands'

export const DashboardCommands = {
  addDashboard(s: EditorService) {
    const dashboard = { type: 'dashboard', children: [{ text: '' }] }
    Transforms.insertNodes(s.editor, dashboard)
  },

  addWidgetClean(editor: ReactEditor, service: EditorService, widget?: Partial<IDashboardWidgetElement>) {
    Transforms.insertNodes(editor, { type: 'widget', title: 'New Widget', children: [{ text: '' }], ...widget })
  },

  addWidget(editor: ReactEditor, el: IDashboardElement, widget?: IDashboardWidgetElement) {
    const path = ReactEditor.findPath(editor, el.children[el.children.length - 1])
    const offset = ContentCommands.getOffsetOfLastEl(el)
    Transforms.insertNodes(editor, { type: 'widget', title: 'New Widget', children: [{ text: '' }], ...widget }, { at: { path, offset } })
  },

  editWidget(editor: ReactEditor, el: IDashboardWidgetElement, changes: IDashboardWidgetElement) {
    const path = ReactEditor.findPath(editor, el)
    const parent = Node.parent(editor, path)
    Transforms.removeNodes(editor, { at: path })

    const last = path.pop() || 0
    let at: any = []
    // If it is the last widget, we offset the insert to the last character of the new children array
    if (last === parent.children.length - 1) {
      path.push(Math.max(parent.children.length - 2, 0))
      at = { path, offset: ContentCommands.getOffsetOfLastEl(parent) }
    } else { // Otherwise we can just preserve the position
      path.push(last)
      at = path
    }

    Transforms.insertFragment(editor, [changes], { at })
  },

  removeWidget(editor: ReactEditor, el: IDashboardWidgetElement) {
    const path = ReactEditor.findPath(editor, el)
    Transforms.removeNodes(editor, { at: path })
  },
}
